import axios from 'axios';
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import getInvoice from "./payment_get";
import store from "../../../Store"

function _success(success) {
    return {type: 'DELETE_PAYMENT_SUCCESS', success}
}

function _error(error) {
    return {type: 'DELETE_PAYMENT_ERROR', error}
}

function _processing(processing) {
    return {type: 'DELETE_PAYMENT_PROCESSING', processing}
}

function deletePayment(organization_id = null ,payment_id) {
    return (dispatch, getState) => {

        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));
        let {organizationDashboard} = getState()
        let org_id = organization_id || organizationDashboard.data.organization_id;

        let config = {
            headers: {'Authorization': 'Bearer ' + loginToken()},
        };

        axios.delete(apiBaseUrl(`admin/organizations/${org_id}/payments/${payment_id}`), config)

            .then(res => {
                dispatch(_success(res));
                dispatch(_processing(false));
                handleSuccess(res);
                store.dispatch(getInvoice())
            }).catch(error => {
            dispatch(_error(error));
            dispatch(_processing(false));
            handleError(error)

        });
    }
}

export default deletePayment;